import React, { useState } from "react";
import "./Reward.css";

export default function Reward() {
  const [commissions] = useState([
   
  ]);

  return (
    <div className="reward-page">
      {/* Header */}
      <div className="page-header">
        <h2>Rewards List</h2>
        <div className="breadcrumb">
          <a href="/">Home</a> / View All
        </div>
      </div>

      {/* Card */}
      <div className="card">
        <h4>View all Rewards</h4>

        {/* Top actions */}
        <div className="table-actions">
          <div className="left-buttons">
            <button>Copy</button>
            <button>CSV</button>
            <button>Excel</button>
            <button>PDF</button>
            <button>Print</button>
            <button className="dropdown-btn">Column visibility ▾</button>
          </div>
          <div className="right-buttons">
            <button className="btn-create">+ Create New</button>
          </div>
        </div>

        {/* Search Row */}
        <div className="search-box">
          <label>
            Search: <input type="text" />
          </label>
        </div>

        {/* Table */}
        <table className="styled-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Image</th>
              <th>Name</th>
              <th>Points</th>
              <th>Trade</th>
              <th>Sort Order</th>
              <th>Show/Hide</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  No data available
                </td>
              </tr>
            </tbody>
          <tbody>
            {commissions.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.ibCommission}</td>
                <td>{item.amount}</td>
                <td>{item.percent}</td>
                <td>
                  <span
                    className={`status ${
                      item.status === "Active" ? "active" : "inactive"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>
                <td className="actions">
                  {item.status === "Active" ? (
                    <button className="btn-yellow">
                      <i className="fas fa-eye-slash"></i>
                    </button>
                  ) : (
                    <button className="btn-green">
                      <i className="fas fa-eye"></i>
                    </button>
                  )}
                  <button className="btn-blue">
                    <i className="fas fa-edit"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Footer Pagination */}
        <div className="table-footer">
          <p>
            Showing 0 to {commissions.length} of {commissions.length} entries
          </p>
          <div className="pagination">
            <button disabled>Previous</button>
            <button className="active">1</button>
            <button disabled>Next</button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="page-footer">
        <p>
          Copyright © 2025 <span>Ample Markets</span>. All rights reserved.
        </p>
        <p className="version">Version 2.0</p>
      </footer>
    </div>
  );
}

